import { type ServiceAppState } from '@kc-console/context';
import { STATUS_CODE } from '@kc-console/core';

import { checkPasswordGuard } from './checkPasswordGuard';

import type { Guard } from '../../../types';

/**
 * Settings 에서 서버사이드 초기 진입 시 호출되어야하는 비밀번호 체크 가드
 * 서버사이드 초기 진입 시의 state 객체에 token 및 domainId 가 존재하기 때문에, 해당 값을 이용하여 비밀번호 체크 로직을 진행합니다.
 */
export const checkPasswordInitialGuard: Guard<ServiceAppState> = async ({
  state,
  context,
  queryClient,
}) => {
  const { status, token, domainId, iamSSREndpoint } = state;

  if (status !== STATUS_CODE.OK) return { status };

  return await checkPasswordGuard({
    context,
    queryClient,
    status,
    token,
    domainId,
    iamEndpoint: iamSSREndpoint,
  });
};

checkPasswordInitialGuard.displayName = 'checkPasswordInitialGuard';
checkPasswordInitialGuard.traceCategory = 'authentication';
